import { useState } from 'react'
import { formatDateLocal } from '../../../../lib/script'
import Button from '../../../common/Button'
import classes from './AlertsItem.module.css'
import ResolveAlerts from './ResolveAlerts'

export default function AlertsItem({itemData}) {
    const [showResolveTask, setShowResolveTask] = useState(false)
    
    function openResolveTask() {
        setShowResolveTask(prevState => prevState = !prevState)
    }

    return <>
        {itemData && <tr className={`${itemData.note_action ? classes.action_row : ''}`}>
            <td className='table-cell-fit'>{itemData.created_at && <>{formatDateLocal(itemData.created_at)}</>}</td>
            <td style={{width: 130}}>{itemData.added_by && itemData.added_by.name}</td>
            <td>
                <div className={classes.padded_cell}>
                    <div dangerouslySetInnerHTML={{ __html: itemData.note }} />
                    {itemData.resolved_note && <div className={classes.item_resolved}>
                        <strong>Resolved Message </strong> {itemData.resolved_note}   
                    </div>}
                    {itemData.assignee_resolved_note && <div className={classes.item_resolved}>
                        <strong>Resolved by {itemData.assignee_resolved_by}</strong> <strong>with note </strong> {itemData.assignee_resolved_note}   
                    </div>}
                </div>
            </td>
            <td className='table-cell-fit'>
                {!itemData.resolved ?  <>
                    <Button click={openResolveTask} btnStyle={'btn_small'}>Resolve</Button>
                </> : <>
                    <div>
                        {formatDateLocal(itemData.resolved_at)}
                    </div>
                    <div>
                        <strong>by</strong> {itemData.resolved_by?.name}
                    </div>
                </>}
            </td>
        </tr>}

        <ResolveAlerts showResolveTask={showResolveTask} openResolveTask={openResolveTask} itemData={itemData}/>
    </>
}